<!-- 产品解决方案 -->
<template>
  <div id="core">
    <div class="title">
      <div class="cover">
          <h1>供应商/经销商</h1>
          <h2>帮助供应商／经销商盘活沉淀在供应链中的资产<br>让企业平等获得金融服务</h2>
      </div>
    </div>
    <header>
      <div class="cover">
        <section>
          <span :class="active === 'N+1' ? 'active' : ''" @click="active = 'N+1'">N+1解决方案</span>
          <span :class="active === '1+N' ? 'active' : ''" @click="active = '1+N'">1+N解决方案</span>
        </section>
        <footer v-if="active === 'N+1'">
          <div class="contant">
            <h2>N+1解决方案</h2>
            <h3>供应商通过群星金融将与核心企业的应收账款转让给金融机构，从而获得新的融资渠道，降低融资成本。金融机构依据核心企业信用状况来确定成本，核心企业获得更稳定的供应链和额外财务收益。</h3>
          </div>
          <img src="/imgs/portal/case/n+1@2x.png" alt="img">
        </footer>
        <footer v-else-if="active === '1+N'">
          <div class="contant">
            <h2>1+N解决方案</h2>
            <h3>经销商通过群星金融将与核心企业的应付账款转让给金融机构，延长付款账期，缓解资金压力，缓解赊销负担，同时提高核心企业资金周转率，增加经营性现金。</h3>
          </div>
          <img src="/imgs/portal/case/1+n@2x.png" alt="img">
        </footer>
      </div>
    </header>
    <div class="advantage" v-if="active === 'N+1'">
      <div class="cover">
        <h1>供应商可以通过该方案改善如下状况</h1>
        <div class="list">
          <div>
            <strong>01</strong>
            <span>提升供应链竞争力</span>
          </div>
          <div>
            <strong>02</strong>
            <span>掌握供应链话语权</span>
          </div>
          <div>
            <strong>03</strong>
            <span>获得财务收益</span>
          </div>
          <div>
            <strong>04</strong>
            <span>更好的资本市场表现</span>
          </div>
        </div>
      </div>
    </div>
    <div class="advantage" v-else-if="active === '1+N'">
      <div class="cover">
        <h1>经销商可以通过该方案改善如下状况</h1>
        <div class="list">
          <div>
            <strong>01</strong>
            <span>解除赊销负担</span>
          </div>
          <div>
            <strong style="margin-bottom:15px;">02</strong>
            <span>延长账期<br>缓解资金压力</span>
          </div>
          <div>
            <strong style="margin-bottom:15px;">03</strong>
            <span>扩大销售规模<br>增强议价能力</span>
          </div>
        </div>
      </div>
    </div>
    <div class="case">
      <div class="cover">
        <h1>我们的案例</h1>
        <img src="/imgs/portal/case/anli1@2x.png" alt="img">
        <img src="/imgs/portal/case/anli2@2x.png" alt="img">
        <img src="/imgs/portal/case/anli3@2x.png" alt="img">
        <h2>……</h2>
      </div>
    </div>
    <div class="form">
      <div class="cover">
        <h1>推荐核心企业使用供应链金融方案，做货款结算的主人</h1>
        <portal-form :from='"case-chain"' :roleType='active'></portal-form>
        <h3>此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。<br>有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的<a href='/pdf/tips.pdf' download="隐私声明">隐私声明</a>。</h3>
      </div>
    </div>
    <portal-footer :page='"download-home"' :roleType='active'></portal-footer>
  </div>
</template>

<script>
import Footer from '../Footer'
import ModelFormVue from '../ModelForm.vue'

export default {
  data () {
    return {
      active: 'N+1'
    }
  },
  created () {
    this.active = this.$route.query.type === 'n1' || !this.$route.query.type ? 'N+1' : '1+N'
  },
  watch: {
    $route (to) {
      this.active = to.query.type === 'n1' || !to.query.type ? 'N+1' : '1+N'
    }
  },
  components: {
    'portal-footer': Footer,
    'portal-form': ModelFormVue
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/css/utils";
@import "../../css/theme-config";

#core{
  margin-top: 96px;
  background:#f2f2f2;
  .cover{
    width: 1000px;
    margin: 0 auto;
  }
  .title{
    background: #000000;
    height: 239px;
    color: #FFFFFF;
    h1{
      font-family: PingFangSC-Regular;
      font-size: 24px;
      letter-spacing: 0.5px;
      line-height: 24px;
      margin: 0;
      font-weight: normal;
      padding: 24px 0 6px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }
    h2{
      font-family: PingFangSC-Regular;
      font-size: 28px;
      letter-spacing: 1.17px;
      text-align: center;
      line-height: 48px;
      margin: 40px 0 0;
      font-weight: normal;
    }
  }
  header{
    background: url(/imgs/portal/case/bg1_project@2x.png) center center no-repeat;
    background-size: cover;
    height: 557px;
    padding-top: 40px;
    section{
      width: 282px;
      overflow: hidden;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #FFFFFF;
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 14px;
      margin: 0 auto 26px;
      span{
        display: block;
        float: left;
        width: 140px;
        box-sizing: border-box;
        padding: 14px 0;
        border: 1px solid rgba(255,255,255,0.50);
        cursor: pointer;
      }
      span:first-child{
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
      }
      span:last-child{
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
      }
      .active{
        background: #FFFFFF;
        color: #333333;
        border-color: #FFFFFF;
      }
    }
    footer{
      .contant{
        width: 440px;
        display: inline-block;
        margin-right: 90px;
        vertical-align: top;
        color: #FFFFFF;
        letter-spacing: 0.5px;
        line-height: 30px;
        padding-top: 64px;
        font-family: PingFangSC-Regular;
        h2{
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          line-height: 30px;
          font-weight: normal;
          margin: 0;
          letter-spacing: 0.5px;
        }
        h3{
          letter-spacing: 0.5px;
          font-size: 16px;
          text-align: justify;
          line-height: 26px;
          font-weight: normal;
          margin: 20px 0;
        }
        h5{
          cursor: pointer;
          font-size: 18px;
          color: #66BBFF;
          letter-spacing: 0.38px;
          line-height: 18px;
          padding-right: 15px;
          background: url(/imgs/portal/case/enter1@2x.png) right center no-repeat;
          background-size: 5px 10px;
          width: 90px;
          font-weight: normal;
          margin: 0;
          box-sizing: border-box;
        }
      }
      img{
        width: 464px;
      }
    }
  }
  .advantage{
    padding: 60px 0 70px;
    background: #FFFFFF;
    h1{
      font-family: PingFangSC-Medium;
      font-size: 40px;
      color: #222222;
      letter-spacing: 1.25px;
      text-align: center;
      line-height: 40px;
      font-weight: normal;
      margin: 0;
    }
    .list{
      margin: 50px auto 0;
      overflow: hidden;
      text-align: center;
      div{
        width: 260px;
        height: 260px;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0.43px;
        text-align: center;
        line-height: 28px;
        background: rgba($color: #1F5DEA, $alpha: 0.8);
        border-radius: 100%;
        box-sizing: border-box;
        padding: 60px 0 70px;
        display: inline-block;
        vertical-align: top;
        margin-left: -22px;
        strong{
          opacity: 0.3;
          font-family: PingFangSC-Semibold;
          font-size: 60px;
          letter-spacing: 1.5px;
          display: block;
          line-height: 60px;
          margin-bottom: 30px;
        }
      }
      div:first-child{
        margin-left: 5px;
      }
    }
    h2{
      font-family: PingFangSC-Medium;
      font-size: 38px;
      color: #222222;
      letter-spacing: 1.19px;
      text-align: center;
      line-height: 38px;
      font-weight: normal;
      margin: 0;
    }
    h3{
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #0070C9;
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 24px;
      font-weight: normal;
      margin: 18px auto 52px;
      width: 150px;
      padding-right: 10px;
      background: url(/imgs/portal/case/enter1@2x.png) right center no-repeat;
      background-size: 7px 14px;
      box-sizing: border-box;
      cursor: pointer;
    }
    h5{
      margin: 0;
      font-weight: normal;
      font-family: PingFangSC-Medium;
      font-size: 21px;
      color: #333333;
      letter-spacing: 0.75px;
      text-align: center;
      line-height: 21px;
      overflow: hidden;
      div{
        width: 100px;
        float: left;
        margin-right: 200px;
        img{
          margin: 0 auto;
          display: block;
          &.img-1{
            width: 66px;
          }
          &.img-2{
            width: 73px;
          }
          &.img-3{
            width: 92px;
          }
          &.img-4{
            width: 98px;
          }
        }
      }
      div:last-child{
        margin-right: 0;
      }
    }
  }
  .case{
    background: #191919;
    padding: 36px 0;
    img{
      height: 52px;
      display: block;
      margin: 32px auto;
    }
    h1{
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #FFFFFF;
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 24px;
      margin: 0;
      font-weight: normal;
    }
    h2{
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #FFFFFF;
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 24px;
      margin: 20px 0 0;
    }
  }
  .form{
    background: #FFFFFF;
    padding: 56px 0 70px;
    h1{
      font-family: PingFangSC-Semibold;
      font-size: 36px;
      color: #111111;
      letter-spacing: 1px;
      text-align: center;
      line-height: 36px;
      font-weight: normal;
      margin: 0 0 30px;
    }
    h2{
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0.5px;
      text-align: center;
      line-height: 16px;
      font-weight: normal;
      margin: 12px 0 0;
    }
    h3{
      margin: 12px 0 0;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #A8ACB9;
      letter-spacing: 0.18px;
      text-align: center;
      line-height: 18px;
      font-weight: normal;
      a{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1F5DEA;
        letter-spacing: 0.18px;
        text-align: center;
        line-height: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Chain.vue?f3ef9f1e